import {useEffect} from "react";

import {useQuery} from "@medispend/common/src/components/MSLayout";
import {ResponseState} from "@medispend/common/src/types";
import {useExistingListsContext} from "../../context/ExistingListsContext";
import {getAjax} from "../../services/ajax";


export const useGetToggles = () => {
    const {toggles} = useExistingListsContext();
    const query = useQuery();
    const {setExistingToggles} = useExistingListsContext();

    const refreshEntities = () => {
        const clientId = query.get("clientId");
        const clientInfo = clientId ? `?clientId=${clientId}` : "";
        getAjax(`/api/toggle${clientInfo}`).subscribe((response: ResponseState) => {
            setExistingToggles(response.data);
        });
    };

    useEffect(() => {
        !toggles.length && refreshEntities();
    }, []);

    return refreshEntities;
};
